export const API_CODE_ORIGIN_SUCCESS = '0000';
export const API_CODE_ORIGIN_PARAMETER_INVALID = '9006'; //参数错误
export const API_CODE_ORIGIN_FIRST_LOGIN_NEED_SET_PASSWORD = '1905'; //首次登录，需要设置密码
export const API_CODE_ORIGIN_SECURITY_CENTER_NEED_SET_PASSWORD = '9013'; //安全中心，需要设置密码
export const API_CODE_ORIGIN_LOGIN_SUCCESS = '0'; //登录成功，已退出其他设备的登录状态。
export const API_CODE_ORIGIN_LOGIN_EXPIRED = ['90001', '90000', '9000', '90002']; //登录过期
export const API_CODE_ORIGIN_OTHER_SESSION_KICK_OFF = '9019'; //其他设备登录，已退出当前设备的登录状态。
